import { render, staticRenderFns } from "./shopCar.vue?vue&type=template&id=1163b8e0&scoped=true"
import script from "./shopCar.vue?vue&type=script&lang=js"
export * from "./shopCar.vue?vue&type=script&lang=js"
import style0 from "./shopCar.vue?vue&type=style&index=0&id=1163b8e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1163b8e0",
  null
  
)

export default component.exports